import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';

const PMReportHeader: React.FC = () => {
  return (
    <Box sx={{
      backgroundColor: '#ffffff',
      borderBottom: '2px solid #3b82f6',
      p: 2.5,
    }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <BuildCircleOutlinedIcon sx={{ fontSize: 32, color: '#3b82f6' }} />
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#1e293b' }}>
            Preventive Maintenance Reports
          </Typography>
          <Typography variant="body2" sx={{ color: '#64748b' }}>
            Track PM compliance, costs, and performance across locations and categories
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default PMReportHeader;
